import {detailsNavigationIdsAndValues} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';

export enum DetailsPageComponents {
  Amenities = 'Amenities',
  RoomSelection = 'RoomSelection',
  Location = 'Location',
  Reviews = 'Reviews',
  FoodGallery = 'FoodGallery',
  FoodDining = 'FoodDining',
  MultiRestraunt = 'MultiRestraunt',
  SingleRestraunt = 'SingleRestraunt',
  HotelAddress = 'HotelAddress',
  ReviewInfo = 'ReviewInfo',
  GoogleMap = 'GoogleMap',
  NavigationMenu = 'NavigationMenu',
  HouseRules = 'HouseRules',
  QuickBookCard = 'QuickBookCard',
  MultiRoomQuickBook = 'MultiRoomQuickBook',
  BookingWidget = 'BookingWidget',
  CaptivateGallery = 'CaptivateGallery',
  CaptivateGalleryV2 = 'CaptivateGalleryV2',
  Gallery = 'Gallery',
  GalleryV2 = 'GalleryV2',
  GalleryPopup = 'GalleryPopup',
  GalleryWithVideo = 'GalleryWithVideo',
  GalleryWithVideoV2 = 'GalleryWithVideoV2',
  DealsDiscoveryModal = 'DealsDiscoveryModal',
  DealsDiscoveryWidget = 'DealsDiscoveryWidget',
  ViewMap = 'ViewMap',
  UGCChipsCard = 'UGCChipsCard',
  AllInclusiveRatePlan = 'AllInclusiveRatePlan',
  AddRoomFlow = 'AddRoomFlow',
  CartFlow = 'CartFlow',
  RecommendedComboList = 'RecommendedComboList',
  Room = 'Room',
  RoomTypeDropDown = 'RoomTypeDropDown',
  GoStaysTag = 'GoStaysTag',
  WideImageModal = 'WideImageModal',
  RatingAndReviews = 'RatingsAndReviews',
  RatingAndReviewsV2 = 'RatingsAndReviewsV2',
  RnRFilters = 'RnRFilters',
  RnRSort = 'RnRSort',
  SimilarProperties = 'SimilarProperties',
  SimilarHotelDetails = 'SimilarHotelDetails',
  TripAdvisor = 'TripAdvisor',
  UserReview = 'UserReview',
  AboutProperty = 'AboutProperty',
  SaleHandling = 'SaleHandling',
  IndiannessSection = 'IndiannessSection',
  LBI = 'LBI',
  AmenitiesSection = 'hd_amenities_data',
  HotelInfo = 'HotelInfo',
  EditCard = 'EditCard',
  Offers = 'Offers',
  GuestReviewsLoaded = 'guest_reviews',
  AltAccoFoodDining = 'AltAccoFoodDining',
  AddOns = 'AddOns',
  HostInfo = 'HostInfo',
  propertyHighlights = 'property_highlights_loaded',
  ElitePackages = 'ElitePackages',
  TravelImpression = 'TravelImpression',

  //RoomSelection
  NRCard = 'NRCard',

  //Hourly
  DayUseGuestDetails = 'DayUseGuestDetails',
  DayUseGallery = 'DayUseGallery',
  DayUseOffers = 'DayUseOffers',
  KnowHourlyPolicies = 'KnowHourlyPolicies',
  HourlyTravelDetails = 'HourlyTravelDetails',
  SlotModal = 'SlotModal',
  RoomDetails = 'RoomDetails',
  DayUseRatingAndReviews = 'DayUseRatingsAndReviews',
  DayUseDetailsAbout = 'DayUseDetailsAbout',
  DayUseHouseRules = 'DayUseHouseRules',
  //Alt Acco - Spaces Layout
  propertyLayout = 'propertyLayout',
}

export const detailsClick = {
  reviewInfo: {
    topGIReviewClick: 'Top_GI_Review_Click',
    topTAReviewClick: 'Top_TA_Review_Click',
    topEXPReviewClick: 'Top_EXP_Review_Click',
    viewMapClick: 'View_Map_Clicked',
  },
  ratingReview: {
    RatingsCardClicked: 'Ratings_card_clicked',
    ReadAllReviewsClicked: 'Read_all_reviews_clicked',
  },
  locationMap: {
    subLocationClick: 'mapwidget_sublocation_selected',
    subLocationClickExpandedMap: 'mapwidget_expanded_sublocation_selected',
    actionButton: 'View_map_reset_button',
    showAllPlaces: 'SHOW_ALL_PLACES',
    showOnlyHotel: 'SHOW_ONLY_HOTEL',
    autoCompletePlaceSearched: 'Map_autocomplete_place_searched',
    autoCompletePlaceSearchedExpandMap: 'Map_expanded_autocomplete_place_searched',
    mapExpanded: 'Map_expanded',
    mapCollapsed: 'Map_collapsed',
    mapZoomIn: 'Map_zoom_in',
    mapZoomOut: 'Map_zoom_out',
    transitExpanded: 'Mapwidget_transit_expanded',
    landmarkExpanded: 'Mapwidget_landmark_expanded',
    othersExpanded: 'Mapwidget_others_expanded',
    searchMade: 'Map_search_made',
    searchMadeExpanded: 'Map_search_made_expanded',
    mapAutosuggestOpened: 'Map_autosuggest_opened',
    mapAutosuggestOpenedExpanded: 'Map_autosuggest_opened_expanded',
    viewMapClick: 'View_Map_Clicked',
    LocationTop: 'LocationInfo_Top_GI_Location_Click',
    LocationCardClicked: 'Location_card_clicked',
    ViewOnMaps: 'View_on_maps',
    ViewNearby: 'View_nearby',
    LocationLandmarks: 'Location_Landmarks',
    LocationTransit: 'Location_Transit',
    LocationOthers: 'Location_Others',
  },
  // navigation,
  nav: {
    [detailsNavigationIdsAndValues.amenities.id]: 'Amenities_Clicked',
    [detailsNavigationIdsAndValues.hotelPolicies.id]: 'Hotel_Policies_Clicked',
    [detailsNavigationIdsAndValues.similarHotels.id]: 'Similar_Hotels_Clicked',
    [detailsNavigationIdsAndValues.location.id]: 'Location_Clicked',
    [detailsNavigationIdsAndValues.aboutProperty.id]: 'About_Property_Clicked',
    [detailsNavigationIdsAndValues.rooms.id]: 'Room_Options_Clicked',
    [detailsNavigationIdsAndValues.foodDining.id]: 'Food_Tapped',
    [detailsNavigationIdsAndValues.guestReviews.id]: 'Guest_reviews',

    //Mweb
    Overview_tapped: 'Overview_tapped',
    Amenities_tapped: 'Amenities_tapped',
    Location_tapped: 'Location_tapped',
    Reviews_tapped: 'Reviews_tapped',
    Address_tapped: 'Address_tapped',
  },
  houseRules: {
    morePoliciesModalClick: 'More_policies_modal_clicked',
    HouseRuleCardClicked: 'HouseRules_card_clicked',
    ViewAllRules: 'View_all_rules',
  },
  detailsQuickBook: {
    quickbook_HD_click: 'quickbook_HD_click',
    viewRoomOptionsLabel: 'quickbook_viewroomoptions',
  },
  bookingWidget: {
    viewXRoomOptionsClick: 'Room_option_top_clicked',
  },
  soldout: {
    showAlternateDatesClick: 'Soldout_alternate_click',
    showSimilarHotelsClick: 'Soldout_similar_click',
    seeOtherHotelsClick: 'See_other_hotels_click',
    soldOut: 'Sold_out', // with label Voyagerid_Pax_C/I_C/O,
  },
  captivateGallery: {
    guestGalleryOpenerClick: 'Guest_images',
    hotelGalleryOpenerClick: 'Hotel_images',
    Guest_photos_tab_clicked: 'Guest_photos_tab_clicked',
    Property_photos_tab_clicked: 'Property_photos_tab_clicked',
    tabs: {
      traveller: 'traveller',
      hotellier: 'hotellier',
    },
  },
  captivateGalleryV2: {
    guestGalleryOpenerClick: 'Guest_images',
    hotelGalleryOpenerClick: 'Hotel_images',
    Guest_photos_tab_clicked: 'Guest_photos_tab_clicked',
    Property_photos_tab_clicked: 'Property_photos_tab_clicked',
    tabs: {
      traveller: 'traveller',
      hotellier: 'hotellier',
    },
  },
  bankdeal: {
    details_bank_offer_selected: 'details_bank_offer_selected',
    bank_offer_displayed: 'bank_offer_displayed',
    hotel_offersheet_opened: 'hotel_offersheet_opened',
    knowMoreClicked: 'know_more_clicked',
    offersClicked: 'Offers_clicked',
    offersOldUIClicked: 'Offers_clicked_old_unif',
  },
  ugcChipsCard: {
    whatGuestsLikeClick: 'Guests_Like_Clicked',
    whatYouShouldKnowClick: 'Know_You_Should_Clicked',
    TopViewAllAmenitiesClicked: 'Top_View_All_Amenities_Clicked',
  },
  allInclusiveRatePlan: {
    learnMoreClick: 'Learn_More_Click',
    inclusionItemClicked: 'Inclusion_Item_Clicked',
    bookInclusiveCta: 'Book_Inclusive_CTA_Clicked',
  },
  multiRoomEventActions: {
    multiroom_combo_selected: 'Multiroom_combo_selected',
    Combo_Expand_Clicked: 'Combo_Expand_Clicked',
    Add_room_clicked: 'Add_room_clicked',
    Pax_popup_shown: 'Pax_popup_shown',
    Pax_default_shown: 'Pax_default_shown',
    Book_room_clicked: 'Book_room_clicked',
    Other_options_clicked: 'Other_options_clicked',
    View_combo_clicked: 'View_combo_clicked',
  },
  roomSelection: {
    filterClick: 'Bottom_filter_selected', // with label as filter name
    roomImagesClicked: 'Room_images_clicked',
    viewMoreDetailsModalOpenerClick: 'View_more_details_clicked',
    cancellationPolicyModalOpenerClick: 'Cancellation_policy_clicked',
    eMIModalOpenerClick: 'EMI_clicked',
    signUpInPersuasionTextClick: 'Login_Clicked_Room selection', // pending
    selectButtonClick: 'Select_room_clicked',
    selectRoomPayMode: 'Room_select',
    viewPlanDetailsClick: 'View_Plan_Details_Clicked',
    elitePackageShown: 'hrs_packages_shown',
    elitePackageSelect: 'hrs_package_card_select_clicked',
    elitePackageFilterSelect: 'rs_package_filter_click',
    elitePackageShowAllClick: 'hrs_packages_view_all_button_clicked',
    nrVisible: 'nr_visible',
    nrApplyClicked: 'nr_apply_clicked',
    nrContinueClicked: 'nr_continue_clicked',
  },
  amenities: {
    amenitiesViewAllClick: 'View_all_amenities',
    amenitiesViewLessClick: 'Amenities_View_Less',
    AmenitiesCardClicked: 'Amenities_card_clicked',
  },
  foodDining: {
    foodDiningCardClicked: 'Food_dining_card_clicked',
    foodDiningViewAll: 'View_all_food_dining',
  },
  roomTypeDropDown: {
    room_types_pill: 'room_types_pill',
    rt_pill_room_selected: 'rt_pill_room_selected',
  },
  goStaysTag: {
    gostaysKnowMoreClick: 'gostaysKnowMoreClick_Clicked',
    goStaysClicked: 'goStays_clicked',
  },
  galleryPopup: {
    categoryTapped: 'Category_tapped',
    tabSwitched: 'Tab_switched',
    viewMoreClicked: 'View_more_clicked',
    imageClicked: 'Image_clicked',
    viewRoomClicked: 'Book_room_clicked',
    reviewExpandClicked: 'Review_expand_clicked',
    galleryModalClosed: 'Gallery_modal_closed',
  },
  captivateGalleryLabel: {
    Image: 'Image',
    left_arrow: 'left arrow',
    right_arrow: 'right arrow',
    view_all: 'View All',
    full_screen: 'Full Screen',
    volume: 'Volume',
    Hotel_photos_clicked: 'Hotel_photos_clicked',
    Traveller_photos_clicked: 'Traveller_photos_clicked',
    Traveller_photo_all_clicked: 'Traveller_photos_clicked_view_all',
    Video_clicked: 'Video clicked',
    Video_clicked_view_all: 'VideoVideo_clicked_view_all',
    videoPlayed: 'Video_played',
  },
  rnr: {
    paginationClicked: 'Pagination_Clicked',
    sortClicked: 'Sort_Clicked',
    filterClicked: 'Filter_Clicked',
  },
  similarHotel: {
    similarHotelClicked: 'Similar_properties_clicked',
  },
  tripAdvisor: {
    TAViewAllReviewsClicked: 'TA_view_all_reviews_clicked',
    GIViewAllReviewsClicked: 'GI_view_all_reviews_clicked',
  },
  userReview: {
    readMoreReview: 'Read_More_Review',
    readMoreReply: 'Read_More_Reply',
    reviewImageClicked: 'Image@Review_Clicked',
  },
  aboutProperty: {
    viewMoreClicked: 'View_more_clicked',
    hideClicked: 'Hide_clicked',
  },
  hourly: {
    amenitiesClicked: 'Amenities Clicked',
    policiesClicked: 'Hotel Policies Clicked',
    Top_modify_Clicked: 'Top_modify_Clicked',
    Confirm_slot_clicked: 'Confirm_slot_clicked',
    Final_make_payment_click: 'Final_make_payment_click',
    Bottom_sticky_edit_clicked: 'Bottom_sticky_edit_clicked',
    Edit_guest_details: 'Edit_guest_details',
    View_All_offer: 'View All offer',
    View_room_details_clicked: 'View_room_details_clicked',
    Check_in_Clicked: 'Check_in_Clicked',
    Time_clicked: 'Time_clicked',
    Slot_clicked: 'Slot_clicked',
    Rooms_Guests_Clicked: 'Rooms_Guests Clicked',
    Room_images: 'Room_images',
    Hotel_images: 'Hotel_images',
    Code_changed: 'Code_changed',
    Bottom_slot_clicked: 'Bottom_slot_clicked',
    Share_clicked: 'Share_clicked',
    EnterDetails_clicked: 'EnterDetails_clicked',
    Make_payment_clicked: 'Make_payment_clicked',
    selected_slot_soldout: 'selected_slot_soldout',
    Soldout: 'Soldout',
  },
  indianness: {
    indiannessViewAllClicked: 'indianness_view_all_clicked',
    indiannessCardLoaded: 'indianness_card_loaded',
  },
  propertyLayout: {
    propertylayoutClicked: 'propertylayoutClicked',
    changeRoomClicked: 'propertyLayout_ChangeRoomClicked',
    clickedTopcard: 'propertylayout_clicked_topcard',
  },
  hostInfo: {
    hostCardLoaded: 'host_card_loaded',
    hostCardClicked: 'host_card_clicked',
    hostPhotoClicked: 'host_photo_clicked',
  },
  misc: {
    editCard: 'Edit_Clicked_Card',
  },
  elitePackage: {
    elitePackageLoaded: 'hd_package_data_loaded',
    elitePackageClicked: 'hd_package_card_clicked',
  },
};

export enum DetailsLoaded {
  TripAdvisorToGICta = 'TripAdvisorToGICta',
}
